import {
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {isBoolean} from "util";
import {Subscription} from "rxjs/Subscription";
import {LoadingDataComponent} from "../../loading/loading-data/loading-data.component";

@Directive({
  selector: '[vbLoading]'
})
export class LoadingDirective implements OnDestroy {

  loadingFactory: ComponentFactory<LoadingDataComponent>;
  loadingComponent: ComponentRef<LoadingDataComponent>;

  private asyncSub: Subscription;

  @Input('vbLoading')
  set apploading(loading: boolean | Observable<boolean>) {

    if (isBoolean(loading)) {
      this.loadComponents(loading);
    }

    if (loading instanceof Observable) {
      this.asyncSub = loading.subscribe(res => {
        this.loadComponents(res);
      });
    }

  }

  @Input()
  loadingText;

  private loadComponents(loading: boolean) {
    console.info("Loading: " + loading);
    this.vcRef.clear();

    if (loading) {
      // create and embed an instance of the loading component
      this.loadingComponent = this.vcRef.createComponent(this.loadingFactory);
      if (this.loadingText) {
        this.loadingComponent.instance.loadingText = this.loadingText;
      }
    }
    else {
      // embed the contents of the host template
      this.vcRef.createEmbeddedView(this.templateRef);
    }
  }

  constructor(private templateRef: TemplateRef<any>, private vcRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {
    // Create resolver for loading component
    this.loadingFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingDataComponent);
  }

  ngOnDestroy(): void {
    if (this.asyncSub) {
      this.asyncSub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/loading.directive.ts